import React, { useEffect, useState } from 'react';
import { NavLink, useParams, useLocation } from "react-router-dom";
import Popupform from '../../Components/Popupform/Popupform';
import config from '../../config/config';
import axios from 'axios';
import { FiArrowRight, FiCalendar, FiDollarSign } from 'react-icons/fi';

const Branches = () => {
    const location = useLocation();
    const { banner, subBanner, image } = location.state || {}; // Fallback if state is missing

    // Params are collegeid and courseid based on App.js route
    const { collegeid, courseid } = useParams();

    const [tableData, setTableData] = useState([]);
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        const fetchBranchData = async () => {
            try {
                // If collegeid exists, fetch data. Using the endpoint from original code
                const response = await axios.get(
                    `${config.API_BASE_URL}/api/admin/get_streams_by_courseId/${collegeid}/${courseid}`
                );
                setTableData(response.data.streams || []);
            } catch (error) {
                console.error("Error fetching branch data:", error);
            }
        };
        fetchBranchData();
    }, [collegeid, courseid]);

    const handleOpenPopup = (e) => {
        if (e) e.preventDefault();
        setShowPopup(true);
        document.body.style.overflow = "hidden";
    };

    const handleClosePopup = () => {
        setShowPopup(false);
        document.body.style.overflow = "auto";
    };

    useEffect(() => {
        return () => { document.body.style.overflow = "auto"; };
    }, []);

    return (
        <div className="bg-white">
            {/* Banner Section */}
            <div className="bg-brand-orange py-16 px-4 relative overflow-hidden text-center md:text-left">
                <div className="absolute inset-0 bg-black/10"></div>
                <div className="container mx-auto relative z-10 flex flex-col md:flex-row items-center gap-8">
                    {/* Logo */}
                    {image && (
                        <div className="w-24 h-24 bg-white rounded-xl p-3 shadow-lg flex-shrink-0 flex items-center justify-center">
                            <img
                                src={`${config.API_BASE_URL}/${image}`}
                                alt="College Logo"
                                className="max-w-full max-h-full object-contain"
                            />
                        </div>
                    )}

                    <div className="flex-grow text-white">
                        <h1 className="text-3xl md:text-4xl font-bold mb-2">
                            {banner || "Available Branches & Streams"}
                        </h1>
                        <p className="opacity-90 text-lg mb-2">
                            {subBanner || "Explore available branches and specializations"}
                        </p>
                        <div className="flex flex-wrap gap-2 text-sm opacity-80">
                            {/* Hardcoded placeholders from original, ideally should be dynamic */}
                            <span>Autonomous University</span> | <span>Estd 1958</span>
                        </div>
                    </div>

                    <div className="flex-shrink-0">
                        <button onClick={handleOpenPopup} className="bg-white text-brand-orange font-bold px-6 py-2 rounded-full shadow-lg hover:bg-orange-50 transition">
                            Apply Now
                        </button>
                    </div>
                </div>
            </div>

            {/* Content Section */}
            <div className="container mx-auto px-4 py-16">
                <div className="text-center mb-10">
                    <h2 className="text-2xl font-bold text-gray-800">Specializations & Streams</h2>
                    <p className="text-gray-500">Select a stream to view more details</p>
                </div>

                <div className="bg-white rounded-3xl shadow-lg border border-gray-100 overflow-hidden max-w-5xl mx-auto">
                    <div className="overflow-x-auto">
                        <table className="w-full min-w-[700px]">
                            <thead className="bg-gray-50 border-b border-gray-100">
                                <tr>
                                    <th className="px-6 py-4 text-left font-bold text-gray-600">Stream Name</th>
                                    <th className="px-6 py-4 text-left font-bold text-gray-600">Total Fees</th>
                                    <th className="px-6 py-4 text-left font-bold text-gray-600">App. Date</th>
                                    <th className="px-6 py-4 text-left font-bold text-gray-600">Action</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-100">
                                {tableData.map((item, index) => (
                                    <tr key={index} className="hover:bg-orange-50/50 transition">
                                        <td className="px-6 py-4">
                                            <NavLink
                                                to={`/streamdetailpage/${item._id}`}
                                                state={{ banner, subBanner, image }} // Pass state forward
                                                className="font-bold text-gray-800 hover:text-brand-orange transition text-lg block"
                                            >
                                                {item.streamsName}
                                            </NavLink>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="flex items-center font-medium text-gray-700">
                                                <FiDollarSign className="mr-1 text-gray-400" /> &#8377; {item.streamsFee}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="flex items-center text-sm text-gray-600">
                                                <FiCalendar className="mr-2 text-gray-400" /> {item.applicationDate}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <button onClick={handleOpenPopup} className="flex items-center text-brand-orange font-bold hover:bg-orange-50 px-3 py-1 rounded transition">
                                                Apply Now <FiArrowRight className="ml-1" />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                {tableData.length === 0 && (
                                    <tr><td colSpan="4" className="text-center py-8 text-gray-500">No streams available.</td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Popup */}
            {showPopup && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
                    <div className="bg-white rounded-2xl shadow-2xl relative w-full max-w-md overflow-hidden max-h-[90vh] overflow-y-auto">
                        <button onClick={handleClosePopup} className="absolute top-4 right-4 text-gray-400 hover:text-gray-800 transition z-10 bg-white rounded-full p-1 border">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                        <Popupform />
                    </div>
                </div>
            )}
        </div>
    );
}

export default Branches;
